// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .tagEnvironment {
  position: fixed;
  bottom: 1em;
  left: 2em;
}
/*# sourceMappingURL=TagEnvDeploy.css.map */`, "",{"version":3,"sources":["webpack://./TagEnvDeploy.less","webpack://./src/components/TagEnvDeploy/TagEnvDeploy.less"],"names":[],"mappings":"AAAA;EAEE,eAAA;EACA,WAAA;EACA,SAAA;ACAF;AACA,2CAA2C","sourcesContent":[".presize-root { \n .tagEnvironment {\n  position: fixed;\n  bottom: 1em;\n  left: 2em;\n}\n \n}",".presize-root .tagEnvironment {\n  position: fixed;\n  bottom: 1em;\n  left: 2em;\n}\n/*# sourceMappingURL=TagEnvDeploy.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
